(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bugani-storyline"] && !Shopify.designMode) return;
  try {
    

if (!customElements.get('bugani-story-viewer')) {
  customElements.define('bugani-story-viewer', class extends HTMLElement {
    connectedCallback() {
      if (this.zoomReady) return;
      const dialog = this.querySelector('.bugani-story__dialog');
      if (!dialog) return;
      this.zoomReady = true;
      const viewport = dialog.querySelector('.bugani-story__zoom-viewport');
      const image = dialog.querySelector('img');
      let opener;
      let previousOverflow;
      let imageWidth = 0;
      const resize = (width) => {
        imageWidth = Math.max(viewport.clientWidth, Math.min(width, image.naturalWidth * 2 || 2000));
        image.style.width = imageWidth + 'px';
      };
      this.addEventListener('click', (event) => {
        const link = event.target.closest('[data-story-zoom]');
        if (!link || !this.contains(link)) return;
        if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
        event.preventDefault();
        opener = link;
        previousOverflow = document.body.style.overflow;
        image.alt = link.querySelector('img').alt;
        image.onload = () => { resize(image.naturalWidth); viewport.scrollTo(0, 0); };
        image.style.width = '100%';
        image.src = link.href;
        dialog.showModal();
        document.body.style.overflow = 'hidden';
        viewport.scrollTo(0, 0);
      });
      dialog.querySelector('[data-zoom-in]').addEventListener('click', () => resize(imageWidth * 1.25));
      dialog.querySelector('[data-zoom-out]').addEventListener('click', () => resize(imageWidth / 1.25));
      dialog.querySelector('[data-zoom-fit]').addEventListener('click', () => { resize(viewport.clientWidth); viewport.scrollTo(0, 0); });
      dialog.querySelector('[data-zoom-close]').addEventListener('click', () => dialog.close());
      dialog.addEventListener('close', () => { document.body.style.overflow = previousOverflow || ''; opener?.focus({preventScroll:true}); });
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lifnex-brand-story"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('lifnex-brand-story')) {
    customElements.define('lifnex-brand-story', class extends HTMLElement {
      connectedCallback() {
        this.querySelectorAll('[data-ln-carousel]').forEach(carousel => {
          if (carousel.dataset.initialized === 'true') return;
          carousel.dataset.initialized = 'true';
          const slides = [...carousel.querySelectorAll('[data-ln-slide]')];
          const dots = [...carousel.querySelectorAll('[data-ln-carousel-dot]')];
          const status = carousel.querySelector('[data-ln-carousel-status]');
          const toggle = carousel.querySelector('[data-ln-carousel-toggle]');
          const toggleLabel = carousel.querySelector('[data-ln-carousel-toggle-label]');
          if (slides.length < 2) return;
          let currentIndex = 0;
          let timer;
          const showSlide = index => {
            currentIndex = (index + slides.length) % slides.length;
            slides.forEach((slide, slideIndex) => {
              slide.hidden = slideIndex !== currentIndex;
              slide.setAttribute('aria-label', `${slideIndex + 1} of ${slides.length}`);
            });
            dots.forEach((dot, dotIndex) => dot.setAttribute('aria-current', dotIndex === currentIndex ? 'true' : 'false'));
            if (status) status.textContent = `${currentIndex + 1} / ${slides.length}`;
          };
          let paused = false;
          const stopTimer = () => window.clearInterval(timer);
          const updateToggle = () => {
            if (!toggle || !toggleLabel) return;
            toggle.setAttribute('aria-pressed', paused ? 'true' : 'false');
            toggleLabel.textContent = paused ? '▶' : 'Ⅱ';
            toggle.setAttribute('aria-label', paused ? 'Resume automatic slideshow' : 'Pause automatic slideshow');
          };
          const startTimer = () => {
            stopTimer();
            if (!paused) timer = window.setInterval(() => showSlide(currentIndex + 1), Math.max(3000, Number(carousel.dataset.interval) || 5000));
          };
          toggle?.addEventListener('click', () => {
            paused = !paused;
            updateToggle();
            startTimer();
          });
          document.addEventListener('visibilitychange', () => document.hidden ? stopTimer() : startTimer());
          carousel.querySelector('[data-ln-carousel-prev]')?.addEventListener('click', () => showSlide(currentIndex - 1));
          carousel.querySelector('[data-ln-carousel-next]')?.addEventListener('click', () => showSlide(currentIndex + 1));
          dots.forEach((dot, dotIndex) => dot.addEventListener('click', () => showSlide(dotIndex)));
          carousel.addEventListener('keydown', event => {
            if (event.key === 'ArrowLeft') showSlide(currentIndex - 1);
            if (event.key === 'ArrowRight') showSlide(currentIndex + 1);
          });
                      const track = carousel.querySelector('.ln-story__carousel-track');
            let pointerStartX = 0;
            let pointerStartY = 0;
            let pointerActive = false;
            track?.addEventListener('pointerdown', event => {
              if (event.pointerType === 'mouse' && event.button !== 0) return;
              pointerStartX = event.clientX;
              pointerStartY = event.clientY;
              pointerActive = true;
              track.setPointerCapture(event.pointerId);
            });
            track?.addEventListener('pointerup', event => {
              if (!pointerActive) return;
              pointerActive = false;
              const deltaX = event.clientX - pointerStartX;
              const deltaY = event.clientY - pointerStartY;
              if (Math.abs(deltaX) > 40 && Math.abs(deltaX) > Math.abs(deltaY)) {
                showSlide(currentIndex + (deltaX < 0 ? 1 : -1));
              }
            });
            track?.addEventListener('pointercancel', () => { pointerActive = false; });
            track?.addEventListener('dragstart', event => event.preventDefault());
          updateToggle();
          startTimer();
        });
        if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches || window.Shopify?.designMode) return;
        this.revealObserver = new IntersectionObserver(entries => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              entry.target.dataset.lnReveal = 'visible';
              this.revealObserver.unobserve(entry.target);
            }
          });
        }, { threshold: 0.08, rootMargin: '0px 0px 0px 0px' });
        this.querySelectorAll('[data-ln-reveal]').forEach(element => {
          if (element.getBoundingClientRect().top > window.innerHeight) element.dataset.lnReveal = 'pending';
          this.revealObserver.observe(element);
        });
      }
      disconnectedCallback() { this.revealObserver?.disconnect(); }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
